var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "video" } },
    [
      _c("b-embed", {
        attrs: {
          type: "iframe",
          aspect: _vm.getVideoRatio(),
          src: _vm.src,
          allow: "autoplay; fullscreen",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }